import { Checkbox, type CheckboxProps } from "@mui/material";
import { useId, useState } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button";
import { MoreDetailsDrawer } from "@/components/MoreDetailsDrawer/MoreDetailsDrawer";

type Props = CheckboxProps;

export const TermsAndConditions = (props: Props) => {
  const intl = useIntl();
  const checkboxId = useId();
  const [moreDetailsOpen, setMoreDetailsOpen] = useState(false);

  return (
    <>
      <div className="flex gap-2">
        <div className="shrink-0">
          <Checkbox id={checkboxId} sx={{ p: 0 }} {...props} />
        </div>

        <div className="flex flex-col items-start gap-1 pt-1">
          <label
            className="text-sm font-semibold text-text-primary"
            htmlFor={checkboxId}
          >
            {intl.formatMessage({ id: "hotels.acceptGeneralTerms" })}
          </label>
          <div className="text-sm text-text-tertiary">
            {intl.formatMessage({ id: "hotels.acceptGeneralTermsWarning" })}
          </div>
          <Button
            size="small"
            variant="textFit"
            onClick={() => setMoreDetailsOpen(true)}
          >
            {intl.formatMessage({ id: "moreDetails" })}
          </Button>
        </div>
      </div>

      <MoreDetailsDrawer
        open={moreDetailsOpen}
        onClose={() => setMoreDetailsOpen(false)}
      />
    </>
  );
};
